import { Cell, Pie, PieChart, Legend } from "recharts";
import { Typography } from "@mui/material";

// // #region Sample data
// const data = [
//   { name: "Group A", value: 400 },
//   { name: "Group B", value: 300 },
//   { name: "Group C", value: 300 },
//   { name: "Group D", value: 200 },
// ];

// #endregion
const RADIAN = Math.PI / 180;

const renderLegend = (props) => {
  const { payload } = props;
  // console.log(payload);
  // Sort or reorder the payload array here as needed
  const sortedPayload = [...payload].sort(
    (a, b) => a.payload.order - b.payload.order,
  );

  return (
    <div>
      {sortedPayload.map((entry, index) => (
        <Typography
          variant="body2"
          fontWeight={700}
          key={`item-${index}`}
          sx={{ color: entry.color }}
        >
          {entry.value}
        </Typography>
      ))}
    </div>
  );
};

const renderCustomizedLabel = (props) => {
  if (
    props.cx == null ||
    props.cy == null ||
    props.innerRadius == null ||
    props.outerRadius == null
  ) {
    return null;
  }
  // console.log(props);
  const radius =
    props.innerRadius + (props.outerRadius - props.innerRadius) * 0.5;
  const ncx = Number(props.cx);
  const x = ncx + radius * Math.cos(-(props.midAngle ?? 0) * RADIAN);
  const ncy = Number(props.cy);
  const y = ncy + radius * Math.sin(-(props.midAngle ?? 0) * RADIAN);

  return (
    <text
      x={x}
      y={y}
      style={{ fontWeight: "bold", fontFamily: "Roboto" }}
      fill="white"
      textAnchor={x > ncx ? "start" : "end"}
      dominantBaseline="central"
    >
      {props.value > 0 ? props.value : ""}
    </text>
  );
};

export default function PieChartView({ data }) {
  return data !== undefined &&
    data.length > 0 &&
    data.filter((item) => item.value > 0).length > 0 ? (
    <PieChart
      className="RechartsHide"
      style={{ height: "14vh", marginLeft: 6 }}
      responsive
    >
      <Pie
        data={data}
        labelLine={false}
        label={renderCustomizedLabel}
        fill="#8884d8"
        dataKey="value"
        startAngle={90}
        endAngle={-270}
        isAnimationActive={true}
        style={{ outline: "none" }}
      >
        {data
          .sort((a, b) => a.order - b.order)
          .map((entry, index) => (
            <Cell key={index} fill={entry.color} style={{ outline: "none" }} />
          ))}
      </Pie>
      <Legend
        layout="vertical"
        verticalAlign="middle"
        align="left"
        content={renderLegend}
      />
    </PieChart>
  ) : null;
}
